import { combineReducers } from 'redux';
import installations from './reducer/installations';

export default combineReducers({
  installations
})
